
const m = window.require("embercom/models/data/inbox/channels");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
